import axios from 'axios'
import { get, isObject } from 'lodash'
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'

import Alert from '../Alert'
import Button from '../Button'
import Dialog from '../Dialog'
import Panel from './Panel'

type TStatusPanel = {
  url?: string
}
const StatusPanel = (props: TStatusPanel): React.ReactElement => {
  const { url } = props

  const [show, setShow] = useState(false)
  const [statusItem, setStatusItem] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)
  const [hasError, setError] = useState(false)

  const fetchData = async (): Promise<void> => {
    try {
      setIsLoading(true)
      const { data } = await axios({
        method: 'get',
        url,
        headers: {
          Authorization: `Bearer ${get(global, 'bearertoken')}`,
          'Accept-Language': i18n?.language ?? 'de',
        },
      })
      setStatusItem(data)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
      setError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const handelOpen = (status: boolean): void => {
    setShow(status)
    if (status) {
      fetchData()
    } else {
      setStatusItem(undefined)
      setError(false)
    }
  }
  return (
    <React.Fragment>
      <Button textOnly icon="fas fa-server" onClick={() => handelOpen(true)} />

      <Dialog
        show={show}
        isLoading={isLoading}
        onHide={() => handelOpen(false)}
        title={i18n.t('service_package', 'Ihr Servicepaket')}
      >
        {!isLoading && hasError && (
          <Row>
            <Col>
              <Alert variant="danger">
                {i18n.t('error_fetching_data', 'Fehler beim Abrufen der Daten')}
              </Alert>
            </Col>
          </Row>
        )}

        {!hasError && isObject(statusItem) && <Panel item={statusItem} />}
        <React.Fragment>
          <Row>
            <Col md={12} className="d-flex justify-content-end">
              <Button light onClick={() => handelOpen(false)}>
                {i18n.t('close', 'Schließen')}
              </Button>
            </Col>
          </Row>
        </React.Fragment>
      </Dialog>
    </React.Fragment>
  )
}

export default StatusPanel
